module.exports = new __parcel__URL__("level_10_tab_active.916db09d.png").toString();